// SNS Infinite Scroll
// Carga automática de todas las páginas de productos dentro de la misma colección.
//
// IMPORTANTE:
// - La primera tanda puede ser randomizada por sns-collection-randomizer.js.
// - Cuando se cargan más productos, los productos YA visibles NO se mueven.
// - Solo el lote NUEVO puede randomizarse.
// - La paginación HTML sigue existiendo como fallback/crawl,
//   pero se oculta visualmente cuando JavaScript funciona.

const COLLECTION_STATE_KEY = 'sns_collection_state_v2';


function isBackNavigation() {
  try {
    const navEntries = performance.getEntriesByType('navigation');

    if (navEntries && navEntries.length > 0) {
      return navEntries[0].type === 'back_forward';
    }

    if (performance && performance.navigation) {
      return performance.navigation.type === 2;
    }
  } catch (e) {
    console.warn(
      'InfiniteScroll: no se pudo detectar tipo de navegación',
      e
    );
  }

  return false;
}


class InfiniteScroll {

  constructor() {

    this.container =
      document.querySelector('#product-grid');


    /*
      Paginación normal de Dawn.
    */
    this.pagination =
      document.querySelector('.pagination-wrapper');


    /*
      SNS crawl fallback:
      Page 1 of 2 / More products →
    */
    this.crawlLinks =
      document.querySelector(
        '[data-sns-crawl-links]'
      );


    /*
      Si no existe grid de productos,
      no hacemos nada.
    */
    if (!this.container) {
      this.showBodyIfHidden();
      return;
    }


    /*
      Encontramos la siguiente página.
    */
    this.nextPageUrl =
      this.getNextPageUrlFromDocument(
        document
      );


    /*
      Estado para regresar con BACK.
    */
    this.stateKey =
      this.getStateKey();


    this.isBack =
      isBackNavigation();


    this.restoredState =
      this.isBack
        ? this.restoreState()
        : null;


    /*
      Si restauramos una navegación anterior,
      usamos la próxima página guardada.
    */
    if (
      this.restoredState &&
      this.restoredState.nextPageUrl !== undefined
    ) {

      this.nextPageUrl =
        this.restoredState.nextPageUrl;

    }


    this.loading = false;
    this.preloading = false;

    /*
      Precargar antes de llegar al final.
    */
    this.preloadThreshold = 2400;

    /*
      Agregar productos antes de que el cliente
      llegue al footer.
    */
    this.loadThreshold = 1600;

    this.cachedPage = null;
    this.initialized = false;


    /*
      El visitante nunca debe ver
      paginación manual si JS funciona.
    */
    this.hideNavigation();


    /*
      Si no hay otra página,
      terminamos normalmente.
    */
    if (!this.nextPageUrl) {

      window.addEventListener(
        'beforeunload',
        () => {
          this.saveState();
        }
      );

      this.showBodyIfHidden();

      return;
    }


    this.init();


    window.addEventListener(
      'beforeunload',
      () => {
        this.saveState();
      }
    );


    this.showBodyIfHidden();
  }



  /* =========================================================
     BODY / BACK RESTORE
     ========================================================= */

  showBodyIfHidden() {

    document.documentElement.classList.remove(
      'sns-restore-pending'
    );

  }



  getStateKey() {

    return (
      `${COLLECTION_STATE_KEY}:` +
      window.location.pathname
    );

  }



  restoreState() {

    try {

      const raw =
        sessionStorage.getItem(
          this.stateKey
        );


      if (!raw) {
        return null;
      }


      const state =
        JSON.parse(raw);


      const savedPath =
        (state.url || '').split('?')[0];


      const currentPath =
        window.location.pathname;


      if (
        savedPath !== currentPath
      ) {
        return null;
      }


      /*
        Restauramos el grid que el cliente
        ya había cargado.
      */
      if (state.html) {

        this.container.innerHTML =
          state.html;

      }


      const targetScroll =
        typeof state.scrollY === 'number'
          ? state.scrollY
          : 0;


      window.scrollTo(
        0,
        targetScroll
      );


      return state;


    } catch (e) {

      console.warn(
        'InfiniteScroll: error restaurando estado',
        e
      );

      return null;

    }

  }



  saveState() {

    try {

      if (!this.container) return;


      const state = {

        url:
          window.location.pathname +
          window.location.search,

        html:
          this.container.innerHTML,

        nextPageUrl:
          this.nextPageUrl,

        scrollY:
          window.scrollY,

        timestamp:
          Date.now()

      };


      const serialized =
        JSON.stringify(state);


      /*
        Evitar exceder sessionStorage.
      */
      if (
        serialized.length > 3500000
      ) {

        sessionStorage.removeItem(
          this.stateKey
        );

        return;
      }


      sessionStorage.setItem(
        this.stateKey,
        serialized
      );


    } catch (e) {

      console.warn(
        'InfiniteScroll: error guardando estado',
        e
      );

    }

  }



  /* =========================================================
     INITIALIZATION
     ========================================================= */

  init() {

    this.hideNavigation();


    this.setupObserver();


    this.boundHandleScroll =
      this.handleScroll.bind(this);


    window.addEventListener(
      'scroll',
      this.boundHandleScroll,
      {
        passive: true
      }
    );


    this.initialized = true;


    /*
      Comprobación inicial.
    */
    setTimeout(
      () => {
        this.checkPosition();
      },
      150
    );

  }



  /* =========================================================
     HIDE MANUAL PAGINATION
     ========================================================= */

  hideNavigation() {

    /*
      Dawn pagination.
    */
    if (this.pagination) {

      this.pagination.style.display =
        'none';

    }


    /*
      SNS:
      Page 1 of 2 / More products →
    */
    if (this.crawlLinks) {

      this.crawlLinks.style.display =
        'none';

    }

  }



  /* =========================================================
     FIND NEXT PAGE
     ========================================================= */

  getNextPageUrlFromDocument(doc) {

    if (!doc) {
      return null;
    }


    /*
      PRIMERA OPCIÓN:
      SNS crawl links.
    */
    const snsNext =
      doc.querySelector(
        '[data-sns-crawl-links] a[rel="next"]'
      );


    if (
      snsNext &&
      snsNext.href
    ) {

      return snsNext.href;

    }



    /*
      SEGUNDA OPCIÓN:
      paginación normal Dawn.
    */
    const pagination =
      doc.querySelector(
        '.pagination-wrapper'
      ) ||
      doc.querySelector(
        '.pagination'
      );


    if (!pagination) {
      return null;
    }



    let nextLink =
      pagination.querySelector(
        'a[rel="next"]'
      );


    /*
      Dawn English.
    */
    if (!nextLink) {

      nextLink =
        pagination.querySelector(
          'a[aria-label="Next page"]'
        );

    }


    /*
      Fallback aria-label.
    */
    if (!nextLink) {

      nextLink =
        pagination.querySelector(
          'a[aria-label*="next" i]'
        );

    }


    /*
      Fallback por clase Dawn.
    */
    if (!nextLink) {

      const arrows =
        pagination.querySelectorAll(
          '.pagination__item-arrow'
        );


      for (const arrow of arrows) {

        const label =
          (
            arrow.getAttribute(
              'aria-label'
            ) || ''
          ).toLowerCase();


        if (
          label.includes('next')
        ) {

          nextLink = arrow;

          break;

        }

      }

    }


    if (
      nextLink &&
      nextLink.href
    ) {

      return nextLink.href;

    }


    return null;

  }



  /* =========================================================
     SCROLL
     ========================================================= */

  checkPosition() {

    if (
      this.loading ||
      !this.nextPageUrl
    ) {

      return;

    }


    const scrollPosition =
      window.innerHeight +
      window.scrollY;


    const pageHeight =
      document.documentElement.scrollHeight;


    const distanceFromBottom =
      pageHeight -
      scrollPosition;



    /*
      PRELOAD.
    */
    if (
      distanceFromBottom <
        this.preloadThreshold &&
      !this.preloading
    ) {

      this.preloading = true;

      this.preloadNextPage();

    }



    /*
      LOAD.
    */
    if (
      distanceFromBottom <
      this.loadThreshold
    ) {

      this.loadNextPage();

    }

  }



  handleScroll() {

    this.checkPosition();

  }



  /* =========================================================
     PRELOAD
     ========================================================= */

  async preloadNextPage() {

    if (!this.nextPageUrl) {
      return;
    }


    try {

      const response =
        await fetch(
          this.nextPageUrl,
          {
            credentials:
              'same-origin'
          }
        );


      if (!response.ok) {

        throw new Error(
          `HTTP ${response.status}`
        );

      }


      this.cachedPage =
        await response.text();


    } catch (error) {

      console.error(
        'InfiniteScroll preload error:',
        error
      );


      this.cachedPage = null;


    } finally {

      this.preloading = false;

    }

  }



  /* =========================================================
     LOAD NEXT PAGE
     ========================================================= */

  async loadNextPage() {

    if (
      this.loading ||
      !this.nextPageUrl
    ) {

      return;

    }


    this.loading = true;


    this.showLoader();


    /*
      Guardamos la URL exacta
      que estamos cargando.
    */
    const urlToLoad =
      this.nextPageUrl;


    try {

      let html;


      /*
        Usar preload si ya existe.
      */
      if (this.cachedPage) {

        html =
          this.cachedPage;


        this.cachedPage =
          null;


      } else {

        const response =
          await fetch(
            urlToLoad,
            {
              credentials:
                'same-origin'
            }
          );


        if (!response.ok) {

          throw new Error(
            `HTTP ${response.status}`
          );

        }


        html =
          await response.text();

      }



      const parser =
        new DOMParser();


      const doc =
        parser.parseFromString(
          html,
          'text/html'
        );



      /*
        Encontrar solamente el grid
        de productos de la página siguiente.
      */
      const newProductGrid =
        doc.querySelector(
          '#product-grid'
        );


      if (!newProductGrid) {

        throw new Error(
          'Product grid not found in next page'
        );

      }



      /*
        IMPORTANTE:
        solamente productos directos del grid.

        Evita capturar <li> internos
        de componentes/cards.
      */
      const newProducts =
        Array.from(
          newProductGrid.children
        ).filter(
          (element) => {

            return (
              element &&
              element.matches &&
              element.matches(
                'li.grid__item'
              )
            );

          }
        );



      if (
        newProducts.length === 0
      ) {

        this.nextPageUrl = null;

        return;

      }



      /*
        ======================================================
        IMPORTANTE PARA RANDOMIZER
        ======================================================

        NO ponemos:

        data-snscr-ready="false"

        porque eso haría que el randomizer
        interprete todo el grid como nuevo
        y vuelva a mezclar productos
        que el visitante YA vio.

        Simplemente agregamos el nuevo lote
        al FINAL.
        ======================================================
      */


      newProducts.forEach(
        (product) => {

          const clonedProduct =
            product.cloneNode(true);


          this.container.appendChild(
            clonedProduct
          );

        }
      );



      /*
        Buscar si existe otra página después
        de la que acabamos de cargar.
      */
      this.nextPageUrl =
        this.getNextPageUrlFromDocument(
          doc
        );



      /*
        Avisamos al randomizer.

        Él debe randomizar SOLAMENTE
        los productos recién agregados.
      */
      window.dispatchEvent(

        new CustomEvent(
          'infinitescroll:loaded',
          {

            detail: {

              productsAdded:
                newProducts.length

            }

          }
        )

      );



      /*
        Precargar próxima tanda.
      */
      if (
        this.nextPageUrl
      ) {

        setTimeout(
          () => {

            this.preloadNextPage();

          },
          300
        );

      }



    } catch (error) {

      console.error(
        'InfiniteScroll load error:',
        error
      );


    } finally {

      this.loading = false;


      this.hideLoader();


      this.hideNavigation();


      /*
        Si después de agregar productos
        seguimos cerca del final,
        revisamos nuevamente.

        Esto permite cargar otra página
        sin obligar al visitante
        a hacer scroll extra artificial.
      */
      if (
        this.nextPageUrl
      ) {

        setTimeout(
          () => {

            this.checkPosition();

          },
          100
        );

      }

    }

  }



  /* =========================================================
     LOADER
     ========================================================= */

  showLoader() {

    let loader =
      document.querySelector(
        '.infinite-scroll-loader'
      );


    if (!loader) {

      loader =
        document.createElement(
          'div'
        );


      loader.className =
        'infinite-scroll-loader';


      loader.innerHTML = `
        <div class="loading-spinner">

          <svg
            aria-hidden="true"
            focusable="false"
            role="presentation"
            class="spinner"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
          >

            <circle
              class="path"
              fill="none"
              stroke-width="6"
              cx="33"
              cy="33"
              r="30"
            ></circle>

          </svg>

          <p
            style="
              margin-top: 1rem;
              color: rgb(199,199,199);
              font-size: 1.4rem;
            "
          >
            Loading...
          </p>

        </div>
      `;


      this.container.parentNode.insertBefore(
        loader,
        this.container.nextSibling
      );

    }


    loader.style.display =
      'flex';

  }



  hideLoader() {

    const loader =
      document.querySelector(
        '.infinite-scroll-loader'
      );


    if (loader) {

      loader.style.display =
        'none';

    }

  }



  /* =========================================================
     SHOPIFY OBSERVER
     ========================================================= */

  setupObserver() {

    const observer =
      new MutationObserver(
        () => {

          if (
            window.Shopify &&
            window.Shopify.PaymentButton
          ) {

            window.Shopify.PaymentButton.init();

          }

        }
      );


    observer.observe(
      this.container,
      {

        childList: true,

        subtree: false

      }
    );

  }

}



/* ===========================================================
   START
   =========================================================== */

function initSnsInfiniteScroll() {

  /*
    Evitar inicializar dos veces.
  */
  if (
    window.__snsInfiniteScrollInitialized
  ) {

    return;

  }


  window.__snsInfiniteScrollInitialized =
    true;


  new InfiniteScroll();

}



if (
  document.readyState ===
  'loading'
) {

  document.addEventListener(
    'DOMContentLoaded',
    () => {

      setTimeout(
        initSnsInfiniteScroll,
        100
      );

    },
    {
      once: true
    }
  );


} else {

  setTimeout(
    initSnsInfiniteScroll,
    100
  );

}